import { createSlice } from '@reduxjs/toolkit';

export const customFontsSlice = createSlice({
	name: 'customFonts',
	initialState: {
		value: null,
	},
	reducers: {
		selectCustomFonts: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { selectCustomFonts } = customFontsSlice.actions;
export const customFonts = (state) => state.customFonts.value;
export default customFontsSlice.reducer;
